import React from 'react';
import './styles.css';

const GlobalSearchFilter = props => {
  const { data, onClick: onClickHandler } = props;
  const { caption, icon, selected, name } = data;
  let iconClass;

  switch (icon) {
    case 'all':
      iconClass = 'global-search-filter__icon--all';
      break;
    case 'gbs':
      iconClass = 'global-search-filter__icon--gbs-network';
      break;
    case 'network':
      iconClass = 'global-search-filter__icon--network';
      break;
    case 'firms':
      iconClass = 'global-search-filter__icon--firms';
      break;
    case 'reviews':
      iconClass = 'global-search-filter__icon--reviews';
      break;
    case 'jobs':
      iconClass = 'global-search-filter__icon--jobs';
      break;
    case 'inbox':
      iconClass = 'global-search-filter__icon--inbox';
      break;
    default:
      iconClass = null;
  }

  const selectedClass = selected
    ? ' global-search-filter global-search-filter--selected'
    : 'global-search-filter';

  const onClick = () => {
    onClickHandler(name);
  };

  return (
    <button className={selectedClass} onClick={onClick}>
      <span
        className={`global-search-filter__icon ${iconClass}`}
        aria-label={caption}
        role="img"
      />
      <span className="global-search-filter__caption">{caption}</span>
    </button>
  );
};

export default GlobalSearchFilter;
